import { Component, OnInit } from '@angular/core';
import { Application } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-bundles',
  templateUrl: './addBundle.component.html',
  styleUrls: ['./addBundle.component.css']
})
export class AddBundleComponent implements OnInit {

  s: Search;
  data : any = {};
  applicationlist : any = [];
  applicantionmoredetails : any = [];
  color : number = 0
  godownmaxDetails : any = [];
  GodownBundleNo : number = 0;
  GodownSerialNo : number = 0;
  BundleForm :any = [];
  userForm : NgForm;
  likeOperator : boolean = false;
  currentBundle : number = 0;
  fromBundle : number =0;
  toBundle : number =0;
  BundleModel : any =[];
  disable : boolean = false;
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute,private errorHandler: ErrorHandler,
    private formBuilder:ReactiveFormsModule, private fb : FormBuilder ) { 
    this.s = new Search();
  }

  ngOnInit() {
     //GetMaxBundle
     
  }
  

  onSearch(s) {
    debugger;
   
    this.userService.GetMaxBundle()
         .subscribe(
           (data:any) =>{ 
             this.BundleModel = data;
             if(this.BundleModel != null){
              this.currentBundle = data.currentBundle;
              this.fromBundle = data.fromBundle;
              this.toBundle = data.ToBundle;
             }      
            //  console.log('MaxBundleNo');
            //  console.log(this.MaxBundleNumber);
            }
       )        
    this.color = 0;  
    this.applicantionmoredetails = [];
    this.GodownBundleNo = 0;
    this.GodownSerialNo = 0;
    this.currentBundle  = 0;
    this.fromBundle =0;
    document.getElementById('loader-spinner').style.display = "block";
    var searchText = this.s.SearchText;
     var searchCriteria = this.s.SearchCriteria;
     if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
       swal("Warning!", "Please enter the searchby  and search text.", "warning");
    else
     {     
      if(this.likeOperator == true)             
      {        
       this.userService.GetApplicationGodownlist(searchCriteria,searchText)
       .subscribe(
         (data:any) =>{            
           this.applicationlist = data; 
           document.getElementById('loader-spinner').style.display = "none";                      
         }
         , (error) => {
           document.getElementById('loader-spinner').style.display = "none";
           if (error.status == 401) {
             this.errorHandler.HandlerError(error);
           }
           else if (error.status == 400) {
             swal('Warning!', error.error.Message, 'warning');
           }
           else{
             swal('Warning!','Could not load so much of data at a time', 'warning');
           }
         }
       ) 
      }
      else{
        this.userService.GetApplicationGodownlistForReturnRequestequalList(searchCriteria,searchText)
        .subscribe(
          (data:any) =>{            
            this.applicationlist = data; 
            document.getElementById('loader-spinner').style.display = "none";                      
          }
          , (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
            else{
              swal('Warning!','Could not load so much of data at a time', 'warning');
            }}
        ) 
       }      
              
     }
   }

   GetMoreDetails(Id){
     debugger;

    this.disable = false;
    if(this.BundleModel == null){
      swal("Warning!", "Please Contact Vgsl", "warning");
      return;
    }

    document.getElementById('loader-spinner').style.display = "block";
    this.color = Id
     for(let i=0; i<this.applicationlist.length; i++){
       if(Id == this.applicationlist[i].APP_Id){
         this.applicantionmoredetails = this.applicationlist[i];
         this.BundleForm.Bundle_APP_No = this.applicantionmoredetails.APP_No;
         this.BundleForm.Bundle_Reg_No = this.applicantionmoredetails.APP_Reg_No;
         this.BundleForm.Bundle_Old_App_No = this.applicantionmoredetails.APP_M_App_No;        
         this.getDefaultData() 
         document.getElementById('loader-spinner').style.display = "none";            
       }
     }     
   }

   getDefaultData(){
    this.userService.GetMaxGodownDetails()
         .subscribe(
           (data:any) =>{                          
             if(data != null){
              this.godownmaxDetails = data;
              this.GodownBundleNo = this.godownmaxDetails.Bundle_No;
              this.GodownSerialNo = this.godownmaxDetails.Bundle_SerialNo ;
              if(this.GodownSerialNo == 100){               
                  this.GodownBundleNo = this.currentBundle + 1;
                  this.GodownSerialNo = 1;                      

              }
              else{         
               this.GodownBundleNo = this.GodownBundleNo;
               this.GodownSerialNo = this.GodownSerialNo + 1;                
              }
             }
             else{
              this.GodownBundleNo = this.fromBundle;
              this.GodownSerialNo = 1;
             }  
             
             this.BundleForm.Bundle_SerialNo = this.GodownSerialNo;
             this.BundleForm.Bundle_No = this.GodownBundleNo;             
             //this.BundleForm.Bundle_No = 16501;  
           }
         )          
   }

   Save(bundleForm:NgForm){ 
     debugger;     
    this.disable = true;
    console.log('bundleForm.value.Bundle_No');
    console.log(this.BundleForm.Bundle_No);
    document.getElementById('loader-spinner').style.display = "block"; 

    if((+this.BundleForm.Bundle_No < this.fromBundle) || (+this.BundleForm.Bundle_No >this.toBundle)){
      swal("Warning!", "Bundle No not belongs to this user", "warning");
      document.getElementById('loader-spinner').style.display = "none"; 
      return;
    }

    bundleForm.value.Bundle_APP_No = this.BundleForm.Bundle_APP_No;
    bundleForm.value.Bundle_Reg_No = this.BundleForm.Bundle_Reg_No;
    bundleForm.value.Bundle_Old_App_No = this.BundleForm.Bundle_Old_App_No;
    bundleForm.value.Bundle_SerialNo = this.BundleForm.Bundle_SerialNo;
    bundleForm.value.Bundle_No = this.BundleForm.Bundle_No;
    
    this.data = this.userService.PostBundle(bundleForm.value);    
    this.data.subscribe(
      (response) => {               
        swal('Success!', 'Bundle Added Successfully .', 'success');        
        bundleForm.reset()         
        document.getElementById('loader-spinner').style.display = "none";           
      }, (error) => {
        this.disable = false;
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
   }

   clear(){    
    this.applicationlist = {};
    this.applicantionmoredetails = [];
    this.GodownBundleNo = 0;
    this.GodownSerialNo = 0;
   }

   Cancel(){    
    this.applicationlist = [];
    this.applicantionmoredetails = [];
    this.GodownBundleNo = 0;
    this.GodownSerialNo = 0;
   }

   handleChange(evt) {    
    var target = evt.target;
    if (target.checked) {
     this.likeOperator = true
    } else {
      this.likeOperator = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Godown/addBundle/addBundle.component.ts